import Vue from "vue";
Vue.directive('has', {
    inserted(el, bindings, vnode) {
        setTimeout(() => {
            let btnPermissionValue = bindings.value;
            let PermissionSet = vnode.context.$store.state.promiseBtn;
            let boolean = PermissionSet.includes(btnPermissionValue);
            //!boolean && el.parentNode.removeChild(el);
            if (!boolean) {
                //el.parentNode.removeChild(el)
                el.disabled = true
            }
        }, 500);

    }
})
    //https://blog.csdn.net/qwyio/article/details/124696702



//////////////////
// WEBPACK FOOTER
// ./config/has.js
// module id = null
// module chunks = 